import { useFilterBirthdayRewardContext } from "./filter-birthday-reward.context";

export function FilterBirthdayReward() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterBirthdayRewardContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}